import * as React from "react";

const InstrumentPizzicatoStrings = (props) => (
  <svg
    id="InstrumentPizzicatoStrings_svg__Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 110.84 110.84"
    style={{
      enableBackground: "new 0 0 110.84 110.84",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {
        ".InstrumentPizzicatoStrings_svg__st85{fill:none;stroke:#fff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}"
      }
    </style>
    
    <path
      d="M94.17 110.84h-77.5C7.46 110.84 0 103.38 0 94.17v-77.5C0 7.46 7.46 0 16.67 0h77.5c9.21 0 16.67 7.46 16.67 16.67v77.5c0 9.21-7.46 16.67-16.67 16.67z"
      style={{
        fill: "#ca5672",
      }}
    />
    <path
      className="InstrumentPizzicatoStrings_svg__st85"
      d="M74.99 2.84 2.85 71.92M95.94 3.33 2.85 92.46M106.92 13.35l-95.65 91.59M107.83 33.02l-78.12 74.8"
    />
  </svg>
);

export default InstrumentPizzicatoStrings;
